export default __webpack_public_path__ + "resources/icons/n341-6a73.png";